// ============================================================================
// ConfRing — circular confidence gauge.
//
// Track + filled arc with the percentage and "confidence" eyebrow centered.
// Colour-codes the fill (green ≥75, amber ≥55, red <55) and drops a soft
// drop-shadow so the value pops on dark surfaces. Sized via `size`; the
// inner type scales with it (~27% for the number, ~8.5% for the label).
//
// The stroke-dashoffset is computed eagerly and rendered as a static
// attribute so SSR/print and prefers-reduced-motion users see the final
// state without animation.
// ============================================================================

export function confColor(value) {
  if (value >= 75) return 'var(--green)';
  if (value >= 55) return 'var(--amber)';
  return 'var(--red)';
}

export default function ConfRing({ value, size = 96, stroke = 8, label = 'confidence' }) {
  const v = Math.max(0, Math.min(100, Number(value) || 0));
  const r = (size - stroke) / 2;
  const circ = 2 * Math.PI * r;
  const off  = circ * (1 - v / 100);
  const col  = v >= 75 ? '#22c55e' : v >= 55 ? '#f59e0b' : '#ef4444';
  return (
    <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }} aria-hidden="true">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--bg-elevated)" strokeWidth={stroke} />
        <circle
          cx={size / 2} cy={size / 2} r={r}
          fill="none" stroke={col} strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circ}
          strokeDashoffset={off}
          style={{ filter: `drop-shadow(0 0 6px ${col})` }}
        />
      </svg>
      <div style={{
        position: 'absolute', inset: 0,
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
      }}>
        <span className="mono" style={{
          fontSize: size * 0.27, fontWeight: 800,
          color: 'var(--text-primary)', lineHeight: 1,
        }}>{Math.round(v)}</span>
        <span className="eyebrow" style={{
          fontSize: Math.max(8, size * 0.085), marginTop: 2,
        }}>{label}</span>
      </div>
    </div>
  );
}
